import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SET_ACCESS_LEVEL_NEW: createActionType(FULL_NAMESPACE, "SET_ACCESS_LEVEL_NEW"),
    SET_ACCESS_LEVEL_KEY: createActionType(FULL_NAMESPACE, "SET_ACCESS_LEVEL_KEY"),
    SAVE_ACCESS_LEVEL: createActionType(FULL_NAMESPACE, "SAVE_ACCESS_LEVEL"),
    DELETE_ACCESS_LEVEL: createActionType(FULL_NAMESPACE, "DELETE_ACCESS_LEVEL")
};
